import { button } from '@groovehq/internal-design-system/lib/styles/elements'
import {
  DRAWER_ID_FOLDERS_CHANNELS_MEMBERS_EDIT,
  DRAWER_ID_FOLDERS_CHANNELS_EMAIL_FORWARD,
} from 'ducks/drawers/ids'
import {
  DRAWER_TYPE_CHANNELS_MEMBERS_EDIT,
  DRAWER_TYPE_CHANNELS_EMAIL_FORWARD,
} from 'ducks/drawers/types'

// NOTE: use useChannelDetailsConfig hook instead of direct import of this file
export default {
  google: {
    drawer: {
      id: DRAWER_ID_FOLDERS_CHANNELS_MEMBERS_EDIT,
      type: DRAWER_TYPE_CHANNELS_MEMBERS_EDIT,
      closeIgnoresStack: true,
    },
    drawerTitle: 'Overview',
    oAuthErrors: {
      ERR_CREATE_MAILBOX: `There was an error creating the ${app.t(
        'mailbox'
      )} in your account.`,
      ERR_CREATE_WIDGET:
        'There was an error creating the chat widget in your account.',
      ERR_USER_CLOSED_POPUP:
        'Oh no! Looks like you closed the authentication pop up. Please try again.',
      ALREADY_AUTHORIZED: (
        <>
          The Groove app has already been authorized on Gmail. Please remove
          it&nbsp;
          <a
            css={button.styles.link}
            target="_blank"
            rel="noopener noreferrer"
            href="https://security.google.com/settings/security/permissions"
          >
            here
          </a>&nbsp; before continuing.
        </>
      ),
      ALREADY_LINKED: `The address is already linked to a different ${app.t(
        'mailbox'
      )} in your Groove account.`,
      ERR_FETCH_OAUTH_URL:
        'An unknown error occurred. This could be due to network connectivity or an error from the authentication service.',
      DEFAULT:
        'An unknown error occurred. This could be due to network connectivity or an error from the authentication service.',
    },
    oAuthSuccess: 'Email address connected successfully.',
  },
  facebook: {
    drawer: {
      id: DRAWER_ID_FOLDERS_CHANNELS_MEMBERS_EDIT,
      type: DRAWER_TYPE_CHANNELS_MEMBERS_EDIT,
      closeIgnoresStack: true,
    },
    drawerTitle: `Add Messenger`,
    oAuthErrors: {
      ERR_CREATE_WIDGET:
        'There was an error creating the chat widget in your account.',
      ERR_VALIDATION_NAME_TAKEN: 'The selected channel name is already in use',
      MISSING_SCOPES:
        'Please allow all requested permissions to make sure this channel works properly',
      ERR_USER_CLOSED_POPUP:
        'Oh no! Looks like you closed the authentication pop up. Please try again.',
      ERR_USER_REJECTED:
        'Oh no! Looks like you canceled the authentication pop up. Please try again.',
      ERR_FETCH_OAUTH_URL:
        'An unknown error occurred. This could be due to network connectivity or an error from the authentication service.',
      MISSING_RESOURCES:
        'Please allow access to at least one page to make sure this channel works properly.',
      MISSING_SPECIFIC_RESOURCE:
        'Please also give permission for the page “{externalName}“.',
      DEFAULT:
        'An unknown error occurred. This could be due to network connectivity or an error from the authentication service.',
    },
  },
  instagram: {
    drawer: {
      id: DRAWER_ID_FOLDERS_CHANNELS_MEMBERS_EDIT,
      type: DRAWER_TYPE_CHANNELS_MEMBERS_EDIT,
      closeIgnoresStack: true,
    },
    drawerTitle: `Add Instagram`,
    oAuthErrors: {
      ERR_CREATE_WIDGET:
        'There was an error creating the chat widget in your account.',
      ERR_VALIDATION_NAME_TAKEN: 'The selected channel name is already in use',
      MISSING_SCOPES:
        'Please allow all requested permissions to make sure this channel works properly',
      ERR_USER_CLOSED_POPUP:
        'Oh no! Looks like you closed the authentication pop up. Please try again.',
      ERR_USER_REJECTED:
        'Oh no! Looks like you canceled the authentication pop up. Please try again.',
      ERR_FETCH_OAUTH_URL:
        'An unknown error occurred. This could be due to network connectivity or an error from the authentication service.',
      MISSING_RESOURCES:
        'Please allow access to at least one page to make sure this channel works properly.',
      MISSING_SPECIFIC_RESOURCE:
        'Please also give permission for the page “{externalName}“.',
      DEFAULT:
        'An unknown error occurred. This could be due to network connectivity or an error from the authentication service.',
    },
  },
  forwarding: {
    drawer: {
      id: DRAWER_ID_FOLDERS_CHANNELS_EMAIL_FORWARD,
      type: DRAWER_TYPE_CHANNELS_EMAIL_FORWARD,
      closeIgnoresStack: true,
    },
  },
}
